<template>
    <form class="card">
        <h3>Общее</h3>
        <div class="inline" v-if="status == ''">
            <div class="grid">
                <div class="form-item">
                    <label for="fname">Фамилия</label>
                    <input type="text" id="fname" class="text-input" v-model="data.firstname" />
                </div>
                <div class="form-item">
                    <label for="sname">Имя</label>
                    <input type="text" id="sname" class="text-input" v-model="data.lastname" />
                </div>
                <div class="form-item checkbox">
                    <input type="checkbox" id="enabled" v-model="data.enabled" />
                    <label for="enabled">Включен</label>
                </div>
            </div>

            <div class="grid">
                <div class="text-item">
                    <span>Дата регистрации</span>
                    <p>{{ data.ctime }}</p>
                </div>
                <div class="form-item">
                    <label for="email">Email</label>
                    <input type="text" id="email" class="text-input" v-model="data.email" />
                </div>
            </div>
            <div class="grid">
                <div class="form-item">
                    <label for="phone">Телефон</label>
                    <input type="text" id="phone" class="text-input" v-model="data.phone" />
                </div>
                <div class="form-item">
                    <label for="dni">DNI</label>
                    <input type="text" id="dni" class="text-input" v-model="data.dni" />
                </div>
            </div>
        </div>
        <div class="grid _free mtop" v-if="status == '' && data.authorizations && data.authorizations.length">
            <h3>Авторизации</h3>
            <table class="table-light">
                <thead>
                <td>id</td>
                <td>дата</td>
                <td>парковка</td>
                <td>статус</td>
                </thead>
                <tr v-for="(item, index) in data.authorizations" :key="index">
                    <td><router-link class="link2" :to="'/authorization/' + item.id">{{ item.id }}</router-link></td>
                    <td>{{ item.ctime }}</td>
                    <td><router-link class="link2" :to="'/parking/' + item.parking.id">{{ item.parking.address}}</router-link></td>
                    <td>{{ item.status_text }}</td>
                </tr>
            </table>
        </div>
    </form>
</template>

<script>
    export default {
        props: ['status', 'data'],
        created () {
            this.$emit('getData')
        }
    }
</script>